module.exports = __webpack_public_path__ + "static/test1-84508cdc19dc4d73c01ea2eec7fcb8a4.jpg";